// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tooltips-page{margin-left:20px;margin-right:20px}.tooltips-page .table-header{padding:10px}.tooltips-page .table-header .title{font-size:24px;font-weight:600}.tooltips-page .add-new-button{display:inline;float:right;margin-top:5px}", ""]);
// Exports
module.exports = exports;
